import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { TableFilterSection } from '../../styles/BasicStyles';
import TextInput from '../../components/generic/inputs/TextInput';
import SelectInput from '../../components/generic/inputs/SelectInput';
import { GetAllContributors } from '../../infra/requests/ContributorsRequests';

class VehiclesFilters extends Component {
  state = {
    search: '',
    contributor: '',
    contributors: []
  };

  componentDidMount = async () => {
    const { data } = await GetAllContributors();
    this.setState({ contributors: data || [] });
  };

  onInputChange = (field, value, timeout = 0) => {
    this.setState({ [field]: value }, () => {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(this.constructQuery, timeout);
    });
  };

  constructQuery = () => {
    const { queryChange } = this.props;
    const query = {};
    Object.keys(this.state).map((key) => {
      if (this.state[key] && this.state[key] !== '' && key !== 'contributors') {
        query[key] = this.state[key];
      }
      return key;
    });
    queryChange(JSON.stringify(query));
  };

  render() {
    const { search, contributors, contributor } = this.state;
    return (
      <TableFilterSection>
        <Row gutter={24}>
          <Col xs={24} md={10}>
            <TextInput
              input={{
                value: search,
                onChange: (event) =>
                  this.onInputChange('search', event.target.value, 1000)
              }}
              meta={{ valid: true }}
              type="text"
              label="Pesquisar"
              placeholder="Procurar por matricula, marca ou categoria"
            />
          </Col>
          <Col xs={24} md={10}>
            <SelectInput
              label="Colaborador"
              allowClear
              placeholder="Escolha o colaborador"
              data={contributors}
              input={{
                value: contributor,
                onChange: (value) => this.onInputChange('contributor', value)
              }}
              meta={{ valid: true }}
            />
          </Col>
        </Row>
      </TableFilterSection>
    );
  }
}

export default VehiclesFilters;
